import { WritableDraft } from 'immer/dist/internal'
import { IDOOHCampaign } from '@unfoldrtech/portal-mic/dist/src/openapi/core'

export const getSelectedDoohAdGroup = (
  state: WritableDraft<IDOOHCampaign>,
  id: number
) => {
  return state.adGroupsList.find((adGroup) => adGroup.id === id)
}
